<template>
  <div class="scriptInfo">
    <div class="container">
      <div class="header">
        <div class="bg_header">
          <img :src="bgUrl" alt>
        </div>
        <div class="score">{{dramaAvgScore}}</div>
        <div class="infos_stars">
          <div class="stars" v-for="(star, index) in starIcons" :key="index">
            <img class="star" :src="star">
          </div>
        </div>
        <div class="nums">
          <span class="num">{{scoreCount}}</span>
          <span class="info">人评分</span>
        </div>
      </div>
      <div class="content_detail">
        <div class="detail_top">
          <div class="script_infos">
            <p class="script_name">{{dramaName}}</p>
            <p class="script_num">{{palyerCount}}</p>
            <p class="author">
              作者：
              <span class="autor_name">{{authorName}}</span>
            </p>
          </div>
          <p class="script_level">{{level}}</p>
          <p class="line"></p>
        </div>
        <div class="detail_center">
          <div :class="{script_indrouce:true,active:isActive}" ref="message">
            {{newmsg}}
            <span
              v-show="isShow"
              :class="{more:true}"
              @click="toogleChange"
            >{{isActive?"...展开":"收起"}}</span>
          </div>
          <div class="people_photos">
            <ul ref="uls" class="uls">
              <li class="photo" v-for="(item,index) in roleList" :key="index">
                <div class="image">
                  <img :src="item.roleAvatar" alt>
                </div>
                <p class="name">{{item.roleName}}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="detail_footer">
          <p class="compontent_title">精彩评论</p>
          <div class="compontent_list">
            <template v-for="(item,index) in comments">
              <div class="compontents" v-if="index < 11" :key="index">
                <div class="img">
                  <img :src="item.avatar" alt>
                </div>
                <div class="info">
                  <div class="top">
                    <p class="name">{{item.nickname}}</p>
                    <span class="time">{{item.commentTime}}</span>
                  </div>
                  <p class="infos">{{item.comment}}</p>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="money">
          <ul class="autor_avator" ref="autor_avator">
            <template v-for="(item,index) in avatarUrlList">
              <li class="avator" :key="index" v-if="index<8">
                <div class="img_avator">
                  <img :src="item" alt>
                </div>
              </li>
            </template>
          </ul>
          <span class="reward">
            <span class="num">{{rewardTotal}}</span>人打赏
          </span>
          <span class="like_autor" @click="join">喜欢作者</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="image_btn">
        <img src="../assets/images/scriptInfos/start_btn@2x.png" alt>
      </div>
      <div class="btn_mocen" @click="join"></div>
    </div>
    <Appopen
      :title="'我是谜app打开方式'"
      :browser="'1.'+ '点击右上角[...]'"
      :direct="'2. '+'选择[在浏览器中打开]'"
      :isAppopen="isAppopen"
    ></Appopen>
  </div>
</template>
<script>
import { FormatTime, formatNumber, formatTime } from "../assets/js/time.js";
import {appUrlAndroid,appUrlIOS} from "../assets/js/base64"
import StarLight from "../assets/images/scriptInfos/game_star_whole_icon@2x.png";
import StarHalf from "../assets/images/scriptInfos/game_star_half_icon@2x.png";
import StarGray from "../assets/images/scriptInfos/game_star_none_icon@2x.png";
import axios from "axios";
export default {
  data() {
    return {
      isAppopen: false,
      authorName: "",
      times: "",
      scoreCount: "",
      palyerCount: "",
      dramaName: "",
      dramaLabel: "",
      bgUrl: "",
      newmsg: "",
      isActive: false,
      isShow: false,
      dramaScore: "",
      starIcons: null,
      comments: "",
      roleList: [],
      rewardTotal: "",
      avatarUrlList: [],
      count: "",
      dramaAvgScore: "",
      difficulty: "",
      level: "",
      tag:"",
    };
  },
  methods: {
    join(){
       this.baseUrl='https://a.app.qq.com/o/simple.jsp?pkgname=com.wzf.fan'
       var dramaId = this.$route.query.dramaId;
       if (this.isAndroid) {
         window.location.href = this.baseUrl+`&android_schema=${appUrlAndroid( "200002",`wsdid=${dramaId}`)}`;
       } else if (this.isiOS) {
         let ua = navigator.userAgent.toLowerCase();
         if(ua.match(/QQ/i) == "qq"){
           this.isAppopen = true
         }else{
            window.location.href = appUrlIOS('200002',`scriptId=${dramaId}` );
         }
       }else{
          window.location.href = 'http://share.xiyacs.com/#/open'
       }
    },
    isShowBtn(selector) {
      let el = document.querySelector(selector);
      let font_size = parseFloat(
        getComputedStyle(el, null).getPropertyValue("font-size")
      );
      let width = el.clientWidth;
      this.minCount = parseInt(width / font_size) * 2;
      if (this.message.length > this.minCount) {
        this.isShow = true;
      } else {
        this.isShow = false;
        this.isActive = false;
      }
      this.newmsg = this.message.substring(0, this.minCount);
    },
    toogleChange() {
      this.isShowBtn(".script_indrouce");
      this.isActive = !this.isActive;
      if (!this.isActive) {
        this.newmsg = this.message;
      } else {
        this.newmsg = this.message.substring(0, this.minCount + 19);
      }
    }
  },
    components:{
     Appopen: () => import("../component/Appopen.vue")
  },
  created() {
     var u = navigator.userAgent,
      app = navigator.appVersion;
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    document.getElementsByTagName("title")[0].innerText = "我是谜";
    const dramaId = this.$route.query.dramaId;
    axios({
      url: this.$interfaces.getDrameInfo,
      method: "post",
      data: { dramaId: dramaId },
      type: "json"
    })
      .then(res => {
          this.bgUrl = res.data.data.bgUrl,
          this.message = res.data.data.briefIntroduction,
          this.dramaLabel = res.data.data.dramaLabel,
          this.difficulty = res.data.data.difficulty;
          this.theme = res.data.data.theme ? `· ${res.data.data.theme}` : " ";
          this.tag=res.data.data.tags.length===0 ? "":`· ${res.data.data.tags.toString()}`
          this.level = `${this.difficulty} ${this.theme} · ${this.dramaLabel}  ${this.tag}`;
          this.dramaName = res.data.data.dramaName,
          this.dramaScore = res.data.data.dramaScore;
          this.dramaAvgScore = res.data.data.dramaAvgScore;
          this.palyerCount = res.data.data.palyerCount,
          this.scoreCount = res.data.data.scoreCount,
          this.message = res.data.data.briefIntroduction;
          this.toogleChange();
          this.dramaReward = res.data.data.dramaReward;
          this.avatarUrlList = res.data.data.dramaReward.avatarUrlList,
            this.rewardTotal = res.data.data.dramaReward.rewardTotal;
          if (this.rewardTotal >= 300) {
            this.rewardTotal = 300 + "+";
          }
          this.roleList = res.data.data.roleList,
            this.roleList.forEach((item, index) => {
              this.count = index + 1;
            });
          let starIcons = [];
          let intScore = Math.floor(this.dramaScore / 2);
          let hasHalf = this.dramaScore - intScore * 2 > 0;
          for (let i = 0; i < 5; i++) {
            if (i < intScore) {
              starIcons.push(StarLight);
            } else if (i === intScore) {
              if (hasHalf) {
                starIcons.push(StarHalf);
              } else {
                starIcons.push(StarGray);
              }
            } else {
              starIcons.push(StarGray);
            }
          }
          this.starIcons = starIcons;
          this.author = res.data.data.author;
          this.authorName = this.author == null ? "匿名" : this.author.authorName;
          this.comments = res.data.data.comments;
          if (this.comments == null) {
            return;
          } else {
            this.comments.forEach(item => {
              item.commentTime = FormatTime(item.commentTime);
            });
          }
        })
        .catch(err => {
          // console.log(err)
        });
  },
  updated() {
    var liWidth = document.getElementsByClassName("photo")[0].offsetWidth + 1;
    const ulWidth = liWidth * this.count + "px";
    this.$refs.uls.style.width = ulWidth;
  },

};
</script>
<style scoped>
.scriptInfo {
  width: 100%;
  height: 100%;
  position: relative;
}
li {
  list-style: none;
}
.scriptInfo .container {
  width: 100%;
  height: 100%;
  position: relative;
}
.scriptInfo .container .score {
  position: absolute;
  /* .score css 已修改 */
  left: 0.5rem;
  top: 6.05rem;
  width: 3.375rem;
  height: 2.5rem;
  font-size: 1.8rem;
  font-family: "PingFangSC-Semibold";
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 3rem;
  /* background:pink; */
  text-align: center;
}
/* 头 */
.scriptInfo .container .header {
  width: 100%;
}
.scriptInfo .container .header .bg_header {
  width: 100%;
  height: 9.4rem;
  /* background: pink; */
}
.scriptInfo .container .header .bg_header img {
  width: 100%;
  height: 100%;
}
.scriptInfo .container .header .infos_stars {
  position: absolute;
  top: 7.175rem;
  left: 4rem;
  height: 1.25rem;
  line-height: 1.25rem;
  display: flex;
  /* border:0.025rem solid red; */
}
.scriptInfo .container .header .infos_stars .stars {
  width: 0.9rem;
  height: 0.9rem;
  margin-top: 0.09rem;
  margin-right: 0.5rem;
}
.scriptInfo .container .header .infos_stars .stars .star {
  width: 100%;
  height: 100%;
}
.scriptInfo .container .header .nums {
  position: absolute;
  top: 7.175rem;
  right: 0.6rem;
  height: 1.25rem;
  line-height: 1.25rem;
  margin-left: 0.675rem;
}
.scriptInfo .container .header .nums .num {
  font-size: 0.9rem;
  color: white;
  font-family: "PingFangSC-Semibold";
  font-weight: 600;
}
.scriptInfo .container .header .nums .info {
  font-size: 0.6rem;
  color: rgba(255, 255, 255, 0.8);
}
/* 头结束 */
/* content开始 */
.scriptInfo .container .content_detail {
  position: absolute;
  top: 8.8rem;
  width: 100%;
  /* height: 100%; */
  background: white;
  border-radius: 0.25rem 0.25rem 0 0;
  padding-top: 0.9rem;
}
.scriptInfo .container .content_detail .detail_top {
  padding-left: 0.9rem;
  padding-right: 0.9rem;
}
.scriptInfo .container .content_detail .detail_top .script_infos {
  width: 100%;
  display: flex;
  height: 1.25rem;
  line-height: 1.15rem;
  vertical-align: middle;
}
.scriptInfo .container .content_detail .detail_top .script_infos .script_name {
  flex: 57%;
  font-size: 0.9rem;
  font-family: "PingFangSC-Semibold";
  font-weight: 600;
  color: rgba(87, 86, 90, 1);
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.scriptInfo .container .content_detail .detail_top .script_infos .script_num {
  flex: 18%;
  width: 2.8rem;
  height: 1.15rem;
  background: rgba(56, 218, 240, 0.1);
  border-radius: 0.3rem;
  font-size: 0.6rem;
  font-family: "PingFangSC-Semibold";
  font-weight: 600;
  color: rgba(56, 218, 240, 1);
  text-align: center;
  vertical-align: middle;
}
.scriptInfo .container .content_detail .detail_top .script_infos .author {
  flex: 25%;
  font-size: 0.6rem;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  color: rgba(87, 86, 90, 1);
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.scriptInfo
  .container
  .content_detail
  .detail_top
  .script_infos
  .author
  .autor_name {
  font-size: 0.6rem;
  color: #a2b7d4;
}
.scriptInfo .container .content_detail .detail_top .script_level {
  font-size: 0.6rem;
  color: #b9c0cf;
  text-align: left;
  margin-top: 0.3rem;
  word-wrap: break-word;
  white-space: pre-line;

}
.scriptInfo .container .content_detail .detail_top .line {
  height: 0.05rem;
  background: #f0f0f0;
  margin-top: 0.625rem;
  width: 100%;
}
/* center开始 */
.scriptInfo .container .content_detail .detail_center {
  width: 100%;
  margin-top: 0.6rem;
  padding-left: 0.9rem;
  padding-right: 0.9rem;
  text-align: left;
}
/* active 样式 */
.scriptInfo .container .content_detail .detail_center .script_indrouce.active {
  /* 字体样式设置 */
  font-size: 0.75rem;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  color: rgba(87, 86, 90, 1);
  position: relative;
  height: 3.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.scriptInfo .container .content_detail .detail_center .script_indrouce {
  font-size: 0.75rem;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  color: rgba(87, 86, 90, 1);
  position: relative;
}
.more {
  color: #38daf0;
  position: absolute;
  font-size: 0.75rem;
  height: 1.05rem;
  line-height: bottom;
  bottom: 0;
  right: -0.05rem;
}
.scriptInfo .container .content_detail .detail_center .people_photos {
  margin-top: 0.6rem;
  overflow: scroll;
  overflow-x: auto;
  height: 3.25rem;
  overflow-y: hidden;
}
.scriptInfo .container .content_detail .detail_center .people_photos .uls {
  height: 3.25rem;
  padding-left: 0.025rem;
  /* border:0.025rem solid red; */
}
.scriptInfo .container .content_detail .detail_center .people_photos .photo {
  list-style: none;
  float: left;
  padding-right: 0.5rem;
  text-align: center;
}
.scriptInfo
  .container
  .content_detail
  .detail_center
  .people_photos
  .photo
  .image {
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  list-style: none;
  border: 0.025rem solid #cccc;
  overflow: hidden;
}
.scriptInfo
  .container
  .content_detail
  .detail_center
  .people_photos
  .photo
  .image
  img {
  width: 100%;
  height: 100%;
}
.scriptInfo
  .container
  .content_detail
  .detail_center
  .people_photos
  .photo
  .name {
  font-size: 0.6rem;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  color: rgba(87, 86, 90, 1);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 2.4rem;
}
.scriptInfo .container .content_detail .detail_footer {
  padding-left: 0.9rem;
  padding-right: 0.9rem;
  margin-top: 0.625rem;
  width: 100%;
  border-top: 0.025rem solid #f0f0f0;
}
.scriptInfo .container .content_detail .detail_footer .compontent_title {
  margin-top: 0.9rem;
  text-align: left;
  height: 1.25rem;
  font-size: 0.9rem;
  font-family: "PingFangSC-Semibold";
  font-weight: 600;
  color: rgba(87, 86, 90, 1);
  line-height: 1.25rem;
}
.scriptInfo
  .container
  .content_detail
  .detail_footer
  .compontent_list
  .compontents {
  margin-top: 0.9rem;
  width: 100%;
  border-bottom: 0.025rem solid #f0f0f0;
}
.scriptInfo
  .container
  .content_detail
  .detail_footer
  .compontent_list
  .compontents
  .img {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  overflow: hidden;
  border: 0.025rem solid #ccc;
  /* background:pink; */
  float: left;
}
.scriptInfo
  .container
  .content_detail
  .detail_footer
  .compontent_list
  .compontents
  .img
  img {
  width: 100%;
  height: 100%;
}
.scriptInfo
  .container
  .content_detail
  .detail_footer
  .compontent_list
  .compontents
  .info {
  margin-left: 2.1rem;
  position: relative;
  text-align: left;
}
.scriptInfo
  .container
  .content_detail
  .detail_footer
  .compontent_list
  .compontents
  .info
  .top {
  height: 0.825rem;
  line-height: 0.825rem;
  font-weight: 400;
  font-size: 0.6rem;
}
.scriptInfo
  .container
  .content_detail
  .detail_footer
  .compontent_list
  .compontents
  .info
  .top
  .name {
  float: left;
  font-family: "PingFangSC-Regular";
  color: rgba(87, 86, 90, 1);
}
.scriptInfo
  .container
  .content_detail
  .detail_footer
  .compontent_list
  .compontents
  .info
  .top
  .time {
  float: right;
  font-family: "PingFangSC-Regular";
  color: rgba(193, 196, 204, 1);
}
.scriptInfo
  .container
  .content_detail
  .detail_footer
  .compontent_list
  .compontents
  .info
  .infos {
  margin-top: 0.325rem;
  font-size: 0.75rem;
  font-family: "PingFangSC-Medium";
  font-weight: 500;
  color: rgba(87, 86, 90, 1);
  /* 纯英文字母和数字自动换行 */
  word-wrap: break-word;
  white-space: pre-line;
}
/* 评论展开收起 */
.scriptInfo
  .container
  .content_detail
  .detail_footer
  .compontent_list
  .compontents
  .info
  .infos.atc {
  margin-top: 0.325rem;
  font-size: 0.75rem;
  font-family: "PingFangSC-Medium";
  font-weight: 500;
  color: rgba(87, 86, 90, 1);
  text-align: left;
  height: 3.15rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.scriptInfo .container .content_detail .money {
  margin-top: 0.7rem;
  padding-left: 0.9rem;
  padding-right: 0.9rem;
  height: 1.65rem;
  line-height: 1.65rem;
  vertical-align: middle;
  font-size: 0.6rem;
  padding-bottom: 4.7rem;
}
.scriptInfo .container .content_detail .money .autor_avator {
  float: left;
  height: 1.5rem;
  margin-left: 0.025rem;
  margin-top: 0.025rem;
}
.scriptInfo .container .content_detail .money .autor_avator li {
  margin-left: -0.6rem;
  float: left;
  width: 1.5rem;
  height: 1.5rem;
  background: white;
  border-radius: 50%;
  border: 0.025rem solid #ccc;
  overflow: hidden;
}
.scriptInfo .container .content_detail .money .autor_avator li .img_avator {
  width: 1.5rem;
  height: 1.5rem;
}
.scriptInfo .container .content_detail .money .autor_avator li .img_avator img {
  width: 100%;
  height: 100%;
}
.scriptInfo .container .content_detail .money .autor_avator li:first-child {
  margin-left: 0;
  float: left;
  width: 1.5rem;
  height: 1.5rem;
  background: pink;
  border-radius: 50%;
  /* border:0.025rem solid #ccc; */
}
.scriptInfo .container .content_detail .money .num {
  /* margin-left:0.3rem; */
  font-size: 0.9rem;
  font-family: "PingFangSC-Medium";
  font-weight: 500;
  color: rgba(56, 218, 240, 1);
}
.scriptInfo .container .content_detail .money .reward {
  display: inline-block;
}
.scriptInfo .container .content_detail .money .like_autor {
  float: right;
  width: 4.15rem;
  height: 1.65rem;
  background: linear-gradient(
    90deg,
    rgba(48, 207, 238, 1) 0%,
    rgba(83, 255, 246, 1) 100%
  );
  border-radius: 0.825rem;
  font-size: 0.75rem;
  font-family: "PingFangSC-Semibold";
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
}
/* content 结束 */
/* dibu */
.scriptInfo .footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 2.7rem;
  background: linear-gradient(
    90deg,
    rgba(48, 207, 238, 1) 0%,
    rgba(83, 255, 246, 1) 100%
  );
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.scriptInfo .footer .image_btn {
  width: 6rem;
  height: 2.1rem;
}
.scriptInfo .footer .image_btn img {
  width: 100%;
  height: 100%;
}
.scriptInfo .footer .btn_mocen {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 2.7rem;
  /* background:linear-gradient(90deg,rgba(48,207,238,1) 0%,rgba(83,255,246,1) 100%); */
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>




// WEBPACK FOOTER //
// src/components/Scriptinfos.vue